// extracted by mini-css-extract-plugin
export var bounce = "_k5-1";
export var generatingText = "_k5-6";
export var lightning = "_k5-4";
export var popup = "_k5-5";
export var progressBar = "_k5-7";
export var progressFill = "_k5-8";
export var progressShimmer = "_k5-9";
export var progressText = "_k5-a";
export var shimmer = "_k5-3";
export var uploadIcon = "_k5-0";
export var uploadingText = "_k5-2";